import React from 'react';
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function ThemeSelector({ isDarkMode, toggleTheme }) {
  const { t } = useTranslation();

  return (
    <motion.div 
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="theme-selector" 
      style={{
        position: 'fixed',
        right: '20px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1000,
      }}
    >
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={toggleTheme}
        className="cs_btn cs_style_1"
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s ease',
          backgroundColor: isDarkMode ? '#fff' : '#000',
          color: isDarkMode ? '#000' : '#fff',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        {isDarkMode ? (
          <Icon icon="ph:sun-bold" style={{ fontSize: '24px' }} />
        ) : (
          <Icon icon="ph:moon-bold" style={{ fontSize: '24px' }} />
        )}
      </motion.button>
    </motion.div>
  );
} 